import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import * as programEnrollmentUtils from '../common/program-enrollment-utilities';
import * as programUtilities from '../common/program-utilities';
import { ssgFormsAdapters, errorUtilities } from '../common';
import * as touchpointActions from './touchpoints.actions';
import * as programActions from '../programs/program.actions';
import { Title } from '../layout';
import { LoadingPane, SsgFormComponent, ConfirmModalWindow, ssgFormActions, SsgFormAnchor, SsgFormRelation } from '@social-solutions/ssg-forms';
import { toastr } from 'react-redux-toastr';
import './form.scss';
import { Map, List } from 'immutable';

const ssgFormId = "create-form-response";

export class CreateTouchpointResponseComponent extends Component {
  constructor() {
    super();
    this.state = {
      localState: null, // hold the state needed to call save
      localModal: null  // hold a reference to the confirmation modal
    }
  }

  componentWillMount() {
    const { ssgFormActions } = this.props;

    ssgFormActions.hardReset(ssgFormId);
  }

  componentDidMount() {
    const { touchpointActions, match, programActions } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId } = params;

    programActions.fetchAllPrograms();
    touchpointActions.fetchTouchpointForm(siteId, programId, touchpointFormId)
  }

  componentWillUpdate(nextProps, nextState) {
    const { touchpointActions, match: oldMatch, ssgFormActions, programActions } = this.props;
    const { params: oldParams } = oldMatch;
    const { siteId: oldSiteId, programId: oldProgramId, touchpointFormId: oldFormId } = oldParams;

    const { match } = nextProps;
    const { params } = match;
    const { siteId, programId, touchpointFormId } = params;

    // account for the possibility that we are changing to a new form create page
    if (oldSiteId !== siteId || oldProgramId !== programId || oldFormId !== touchpointFormId) {
      ssgFormActions.resetForm(ssgFormId);
      programActions.fetchAllPrograms();
      touchpointActions.fetchTouchpointForm(siteId, programId, touchpointFormId);
    }
  }

  handleSaveClicked(formState) {
    if (formState.validationResult.passedValidation) {
      this.handleValidSave(formState);
    }
}

  handleValidSave(state) {
    const { localModal } = this.state;
    this.setState({localState : state});
    localModal && localModal.show();
  }

  handleConfirmPopupWindowChoice(choice, state) {
    if (choice) {
      this.handleSave(state);
    }
    else {
      this.setState({localState : null});
    }
  }

  handleSave(state) {
    const { touchpointActions, match, redirectTo } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId } = params;
    const { submitTouchpointForm } = touchpointActions;

    var answersMap = this.buildAnswersMap(state);
    submitTouchpointForm(siteId, programId, touchpointFormId, answersMap)
      .then(val => {
        toastr.success('Success', 'Form response saved!');
        redirectTo('/');
      })
      .catch(err => {
        if (!err.validationResult || err.validationResult.isValid)
          toastr.error(err.errorCode, err.errorMessage);
        else {
          touchpointActions.updateShowValidation(ssgFormId, true);
          window.scrollTo(0, 0);
        }
      });
  }

  buildAnswersMap(state) {
    const defaultValueMap = state.defaultValue || {};
    const valuesMap = state.value || {};

    const elementsMap = state.form.elements
    .filter(element => !element.hidden)
    .reduce((acc, element) => {
      // Handle both Immutable Maps and plain JS objects for elements
      const elementId = element.get ? element.get('id') : element.id;
      const elementType = element.get ? element.get('type') : element.type;
      
      acc[elementId] = elementType;

      if (elementType === 'group' && Array.isArray(element.subElements)) {
        element.subElements.forEach(subElement => {
          if (subElement.id !== undefined) {
            acc[subElement.id] = subElement.type;
          }
        });
      }
      return acc;
    }, {});

    const result = Object.keys(defaultValueMap).reduce((acc, key) => {
      if (elementsMap.hasOwnProperty(key)) {
        if (valuesMap.hasOwnProperty(key)) {
          var submitValue = valuesMap[key];
          if (valuesMap[key] == null) {
            if (elementsMap[key] === 'number') {
              submitValue = '0';
            }
          }
          acc[key] = submitValue;
        } else {
          acc[key] = defaultValueMap[key];
        }
      }
      return acc;
    }, {});

    Object.keys(valuesMap).forEach(key => {
      if (!defaultValueMap[key] && !result[key]) {
        result[key] = valuesMap[key];
      }
    });

    return result;
  }


  defaultValuesToImmutable(formDefaults) {
    return new Map(Object.entries(formDefaults).reduce(
      (result, [key, value]) => {
        if (Array.isArray(value)) {
          result[key] = List(value);
        } else if (typeof value === 'object' && value !== null) {
          result[key] = Map(value);
        } else {
          result[key] = value;
        }
        return result;
      },
      {}
    ));
  }

  render() {
    const { touchpoints, match, programEnrollment, redirectTo, programs } = this.props;
    const { params } = match;
    const { siteId, programId, touchpointFormId } = params;

    const allProgs = programUtilities.getAllPrograms(programs);
    const defaultProgs = [programId];

    const touchpointFormState = touchpoints.touchpointForms.get(touchpointFormId);
    const form = !!touchpointFormState && touchpointFormState.data;

    const formDefaults = !!form && form.formDefaults ? this.defaultValuesToImmutable(form.formDefaults) : new Map();

    const fieldFormatSetting = !!form && form.fieldFormatSetting;

    const submissionState = touchpoints.formSubmission.get(touchpointFormId);
    const isSubmitting = !!submissionState && submissionState.isFetching;
    const serverErrors = errorUtilities.getServerErrors(form, submissionState && submissionState.err);

    const formAlias = programEnrollmentUtils.getFormAlias(programEnrollment, siteId, programId, touchpointFormId);
    const displayName = ((!formAlias || formAlias.trim() === '') ? (!!form && form.name ? form.name : '') : formAlias);

    const isUnsupported = form && form.isUnsupported;

    const unsupportedError = isUnsupported ? (
      <div id="unsupported-error" className="form-error-display ssg-forms-text">
        <FontAwesomeIcon icon={faExclamationCircle}/> This form has an error that prevents it from being completed, please contact the organization for support.
      </div>
    ) : null

    const formProps = {
      id: ssgFormId,
      form: {
        ...form,
        name: displayName
      },
      initialValues: formDefaults,
      customValidationErrors: serverErrors,
      customDisplays: [
        {
          position: {
            anchor: SsgFormAnchor.BODY,
            relationship: SsgFormRelation.BEFORE,
          },
          display: unsupportedError,
        }
      ],
      buttonLayout: [
        {
          id: 'close',
          display: 'Cancel',
          buttonType: 'default',
          functionType: 'none',
          onClick: (state) => redirectTo('/'),
        },
        {
          id: 'save',
          display: 'Save',
          type: 'submit',
          buttonType: 'primary',
          functionType: 'submit',
          spinnerOn: isSubmitting,
          disabled: isUnsupported,
          onClick: (state) => this.handleSaveClicked(state),
        }
      ],
      showRequiredKey: true,
      allPrograms: allProgs,
      defaultSelectedPrograms: defaultProgs,
      css: {
        form: "ssg-form form-display",
        formBody: 'ssg-forms-body',
        actions: "ssg-forms-actions form-actions-display",
      },
      country: fieldFormatSetting !== false ? fieldFormatSetting : undefined,
    };

    return (
      <div>
        <Title title="Create Form Response" />
        <LoadingPane id="fetchLoadingPane" loadingState={[ssgFormsAdapters.convertLoadingState(touchpointFormState),
          ssgFormsAdapters.convertLoadingState(programs && programs.allPrograms)]}>
          <ConfirmModalWindow id="create-form-confirm"
            title={"Save Form Response"}
            modalRef={(modal) => this.setState( {localModal : modal})}
            onClose={(e, confirmed) => this.handleConfirmPopupWindowChoice(confirmed, this.state.localState)}>
            <p>{`Are you ready to submit this response to ${displayName}?`}</p>
          </ConfirmModalWindow>
          <SsgFormComponent {...formProps} />
        </LoadingPane>
      </div>
    );
  }
}

CreateTouchpointResponseComponent.propTypes = {
  touchpointActions: PropTypes.object.isRequired,
  touchpoints: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.isRequired,
      programId: PropTypes.isRequired,
      touchpointFormId: PropTypes.isRequired
    })
  })
};

const mapStateToProps = ({ auth, routing, touchpoints, formRules, programEnrollment, programs }) => {
  return {
    auth,
    routing,
    touchpoints,
    programEnrollment,
    programs
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    touchpointActions: bindActionCreators(touchpointActions, dispatch),
    ssgFormActions: bindActionCreators(ssgFormActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    programActions: bindActionCreators(programActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTouchpointResponseComponent);



// WEBPACK FOOTER //
// src/touchpoints/create-touchpoint-response.component.js